import { LogicContext } from '../types';
import { isIframeWrapperEnabled } from '../utils';

export const setHeaderProperties = async (
  context: LogicContext,
  event: { mainLayoutPath: string; pageTitle: string }
) => {
  if (!isIframeWrapperEnabled()) {
    return {
      updates: [],
    };
  }

  const isPathInNavLinks =
    context.navigationLinks &&
    context.navigationLinks.some(link => link === event.mainLayoutPath);

  const isPromotions = !!context.controllersData.promotions;
  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.Header.properties',
          value: {
            ...(!!event.pageTitle && {
              title: event.pageTitle,
            }),
            ...(!isPathInNavLinks &&
              isPromotions && {
                backButtonText: isPathInNavLinks && 'Back',
                title: 'Promotions',
              }),
          },
        },
      },
      {
        type: 'hideLayoutComponent',
        data: 'PageHeader',
      },
    ],
  };
};
